import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetStartedFlow } from '../getstarted/GetStartedFlowContext';
import { removeStoredQueryParams } from '../../utils/queryParamStore';

/**
 * Auto-opens StudioLaunchFlow when reached with `?studio_launch=1`
 * (e.g. Labs Run-gate "Continue as guest").
 */
export function StudioLaunchQueryHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const { open } = useGetStartedFlow();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('studio_launch') !== '1') return;

    params.delete('studio_launch');
    const qs = params.toString();
    navigate({ pathname: location.pathname, search: qs ? `?${qs}` : '' }, { replace: true });
    removeStoredQueryParams('studio_launch');
    open('agent');
  }, [location.pathname, location.search, navigate, open]);

  return null;
}
